<template>
  <div
    class="modal"
    :style="{
      '--backgroundImageSmall': `url(${backgroundImages?.smallMedia})`,
      '--backgroundImageMedium': `url(${backgroundImages?.mediumMedia})`,
      '--backgroundImageLarge': `url(${backgroundImages?.largeMedia})`,
    }"
  >
    <a href="/" class="logo">
      <img src="@/assets/images/logo.svg" class="header__logo" />
    </a>
    <div class="modal__content">
      <div class="modal__video-background">
        <Media
          :sources="[
            {
              url: 'https://cdn.shopify.com/videos/c/o/v/e274301948cc44e79329569a884469f0.mp4',
              mimeType: 'video/mp4',
            },
          ]"
          :preview-images="[
            {
              url: 'https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763',
            },
          ]"
          cover
          autoplay
          loop
          muted
          class="media"
          cover-position="center center"
        />
      </div>
      <div class="modal__content-inner">
        <LandingSuccess v-if="showLandingSuccess" :end-date="endDate" />
        <template v-else-if="shownAccountForm">
          <LandingRegisterForm
            v-if="shownAccountForm === 'register'"
            :end-date="endDate"
            :return-url="'/collections/dresses'"
            @success="handleSuccess"
            @login="shownAccountForm = 'login'"
          />
          <LandingLoginForm
            v-if="shownAccountForm === 'login'"
            return-url="/collections/dresses"
            @success="handleSuccess"
            @register="shownAccountForm = 'register'"
          />
        </template>
      </div>
    </div>
    <div class="modal__images">
      <div class="video-container">
        <Media
          :sources="[
            {
              url: 'https://cdn.shopify.com/videos/c/o/v/e274301948cc44e79329569a884469f0.mp4',
              mimeType: 'video/mp4',
            },
          ]"
          :preview-images="[
            {
              url: 'https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763',
            },
          ]"
          cover
          autoplay
          loop
          muted
          playsinline
          class="media"
          cover-position="center center"
        />
      </div>
      <div class="overlay"></div>
    </div>
  </div>
</template>

<script>
import Media from "@/components/Media.vue";
import LandingRegisterForm from "@/components/landing/LandingRegisterForm.vue";
import LandingLoginForm from "@/components/landing/LandingLoginForm.vue";
import LandingSuccess from "@/components/landing/LandingSuccess.vue";
import { mapGetters } from "vuex";

export default {
  name: "Landing",
  components: {
    Media,
    LandingRegisterForm,
    LandingLoginForm,
    LandingSuccess,
  },
  inject: ["mq"],
  data() {
    return {
      endDate: "2025-04-01T09:00",
      success: false,
      shownAccountForm: "register",
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    showLandingSuccess() {
      return this.success || this.isLoggedIn;
    },
    images() {
      return {
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763",
        largeMedia2x:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763",
      };
    },
    backgroundImages() {
      return {
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763",
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/HIBISCUS_DRESS_1_1.jpg?v=1742295763",
      };
    },
  },
  methods: {
    handleSuccess() {
      this.shownAccountForm = null;
      this.success = true;
    },
  },
};
</script>

<style lang="scss">
#shopify-section-header,
#shopify-section-footer {
  display: none;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  @include respond-above(md) {
    display: flex;
    height: 100vh;
    overflow: hidden;
  }

  &__content,
  &__images {
    flex: 0 0 50%;
    position: relative;
    overflow: hidden;
  }

  .close-btn {
    position: absolute;
    padding: 10px;
    border-radius: 50%;
    top: 8px;
    right: 8px;
    z-index: 1;

    @include respond-above(md) {
      top: 20px;
      right: 20px;
    }
  }
}

.logo {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  filter: invert(1);

  @include respond-above(md) {
    display: none;
  }
}

.modal__content {
  color: $color-white;
  height: 100vh;
  position: relative;
  overflow-y: auto;
  padding-top: 80px;
  background-image: none;

  @include respond-above(md) {
    padding-top: 40px;
    background-image: var(--backgroundImageLarge);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .modal__video-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;

    &::before {
      position: fixed;
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba($color-black, 0.65);
      z-index: 1;
    }

    .media {
      height: 100%;
      width: 100%;
    }

    @include respond-above(md) {
      display: none;
    }
  }

  &::before {
    @include respond-above(md) {
      position: absolute;
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba($color-black, 0.85);
      z-index: 1;
    }
  }
}

.modal__content-inner {
  position: relative;
  z-index: 2;
  text-align: center;
  @extend .containerV2;
  padding: 20px;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;

  @include respond-above(md) {
    padding: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
}

.modal__images {
  display: none;

  @include respond-above(md) {
    display: block;
    position: relative;
    height: 100vh;
    width: 50%;
    overflow: hidden;
    background-color: #000;
  }

  .video-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .media {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.15);
    z-index: 5;
  }
}

.media {
  height: 100%;
  width: 100%;

  &:deep(video) {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
